import jwtInterceptor from 'interceptors/jwtInterceptor'
import { apiNotifications, loadAbort } from 'utilities'

/**
 * Get notifications list with filters for unread/read
 * @param isRead Filter notifications by read status (optional)
 * @param page Page number for pagination
 * @param pageSize Number of items per page
 * @returns Promise with notifications list response
 */
export const getNotifications = (
  isRead?: boolean,
  page = 1,
  pageSize = 10,
  isForManager = true,
  channel = 'SILENT'
) => {
  const controller = loadAbort()
  let url = `${apiNotifications}?page=${page}&page_size=${pageSize}&channel=${channel}&is_for_manager=${isForManager}`

  if (isRead !== undefined) {
    url += `&is_read=${isRead}`
  }

  return {
    call: jwtInterceptor.get(url, {
      signal: controller.signal,
    }),
    controller,
  }
}

/**
 * Get a specific notification by ID
 * @param id Notification ID
 * @returns Promise with notification detail response
 */
export const getNotificationById = (id: string) => {
  const controller = loadAbort()
  return {
    call: jwtInterceptor.get(`${apiNotifications}${id}/`, {
      signal: controller.signal,
    }),
    controller,
  }
}

/**
 * Mark a notification as read
 * @param id Notification ID
 * @returns Promise with response
 */
export const markNotificationAsRead = (id: string) => {
  const controller = loadAbort()
  return {
    call: jwtInterceptor.post(
      `${apiNotifications}${id}/mark_read/`,
      {},
      {
        signal: controller.signal,
      }
    ),
    controller,
  }
}

/**
 * Mark multiple notifications as read
 * @param ids Array of notification IDs
 * @returns Promise with all requests
 */
export const markMultipleNotificationsAsRead = (ids: string[]) => {
  return Promise.all(ids.map(id => markNotificationAsRead(id).call))
}
